import React, { useState } from "react";
import { Avatar, Popover, Skeleton } from "antd";
import "@Styles/main.scss";
import UserService from "@Services/UserService";
import { IUserDetails } from "@Models/IUserDetails";
import { lightenColor, useRunOnce } from "@Utils";
import CountryFlag from "@Components/user/CountryFlag";
import { Countries } from "../../countries";
import SessionManager from "@Core/session";
import { getBranding } from "@Branding";

interface IProps {
    size?: number;
    fullName?: string;
    opacity?: number;
    userId?: string;
}

const UserIcon: React.FC<IProps> = ({ size, fullName, opacity, userId }: IProps) => {
    const [userData, setUserData] = useState<IUserDetails>(null);
    const matches = fullName.match(/(\s|^)([a-z])/gi);
    const initials = matches?.join("").replace(/\s+/g, "");

    useRunOnce(async () => {
        if (userId !== null) {
            const service = new UserService();
            const userResult = await service.getPublic([userId]);
            if (!userResult.hasErrors && userResult.value.length > 0) {
                setUserData(userResult.value[0]);
            }
        }
    });

    return userId === null || userId === SessionManager.getServiceUser()?.userId ? (
        <Avatar size={size} className="avatar-grey no-select">
            {initials}
        </Avatar>
    ) : (
        <Popover
            placement={"bottom"}
            zIndex={999}
            overlayClassName="user-icon-popover"
            content={
                !!userData ? (
                    <div className={"profile-compact"}>
                        <span className={"icon"}>
                            <UserIcon size={size} fullName={fullName} />
                        </span>
                        <span className={"title"}>{fullName}</span>
                        <span className={"meta"}>
                            <CountryFlag size={1.5} countryCode={userData.countryCode} />
                            &nbsp;&nbsp;
                            {Countries.get(userData.countryCode)}
                            {userData.organisation?.length > 0 ?? "&nbsp;&middot;&nbsp;" + userData.organisation}
                        </span>
                    </div>
                ) : (
                    <div className={"profile-compact"}>
                        <Skeleton.Avatar
                            active={true}
                            style={{
                                paddingLeft: "20px",
                                verticalAlign: "middle",
                            }}
                            size={30}
                            shape={"circle"}
                        />
                        &nbsp;&nbsp;
                        <Skeleton.Input
                            active={true}
                            style={{ paddingLeft: "20px", verticalAlign: "middle" }}
                            size={"large"}
                        />
                    </div>
                )
            }
            trigger="hover"
        >
            <Avatar size={size} className="avatar-grey no-select" style={{ opacity: opacity ?? "1" }}>
                {initials}
            </Avatar>
        </Popover>
    );
};
export default UserIcon;

UserIcon.defaultProps = {
    size: 40,
    fullName: "",
    opacity: 1,
    userId: null,
};
